import Stack from "@mui/material/Stack";
import { useTranslation } from "react-i18next";
import { TachographSummary, TachographSummaryFilter } from "../models/Tachograph";
import { filterTileClick, KpiTile } from "@/components/layout/KpiTile";
import { formatNumber } from "@/utilities/formatNumber";

type Props = {
  summary: TachographSummary;
  activeFilter: TachographSummaryFilter;
  onSelect: (filter: TachographSummaryFilter) => void;
  /** Days ahead a readout counts as due, named in the hint of its counter. */
  warningDays: number;
};

/** The three counters above the table. Each one narrows the list down to what it counts. */
export function TachographSummaryCards({ summary, activeFilter, onSelect, warningDays }: Props) {
  const { t, i18n } = useTranslation();

  const cards: Array<{ filter: TachographSummaryFilter; value: number | null; name: string }> = [
    { filter: "all", value: summary.total, name: "totalVehicles" },
    { filter: "downloads", value: summary.downloadsDue, name: "downloadsDue" },
    { filter: "connectors", value: summary.connectorsIssue, name: "connectorsIssue" },
  ];

  return (
    <Stack direction={{ xs: "column", lg: "row" }} spacing={1.5}>
      {cards.map(card => (
        <KpiTile
          key={card.filter}
          label={t(`tachograph.summary.${card.name}`)}
          value={formatNumber(card.value, i18n.language, { precision: 0, missing: "–" })}
          hint={t(`tachograph.summary.${card.name}Hint`, { count: warningDays })}
          selected={activeFilter === card.filter}
          onClick={filterTileClick(card.value, activeFilter === card.filter, () =>
            onSelect(card.filter),
          )}
          minWidth={220}
        />
      ))}
    </Stack>
  );
}
